<script setup lang="ts">
import CourseListItem from "components/course/list/CourseListItem.vue";
import {CourseList} from "@/types";

defineProps<{
  courseList: CourseList | undefined
}>()

const emit = defineEmits(['onCurrentChange', 'onPageSizeChange', "onDelete"])

const onCurrentChange = (currentPage: number) => {
  emit('onCurrentChange', currentPage);
}

const onPageSizeChange = (pageSize: number) => {
  emit('onPageSizeChange', pageSize);
}

const onDelete = (id: number) => {
  emit('onDelete', id);
}
</script>

<template>
  <div>
    <course-list-item
        v-for="course in courseList?.list" :item="course"
        @delete="onDelete">
    </course-list-item>
    <el-pagination
        class="mt-1rem"
        :current-page="courseList?.page || 1"
        :page-size="courseList?.pageSize || 10"
        :total="courseList?.course_count.count || 0"
        layout="prev, pager, next, jumper, ->, total"
        @current-change="onCurrentChange"
        @size-change="onPageSizeChange"
        :hide-on-single-page="true"
    />
  </div>
</template>

<style scoped>
</style>
